import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-custact-calc-pick-select',
  templateUrl: './custact-calc-pick-select.component.html',
  styleUrls: ['./custact-calc-pick-select.component.css'],
  standalone: false
})
export class CustactCalcPickSelectComponent implements OnInit {
    public p2PoFinishKeyno: string;

    public custactNo: string;

    public setting?: Setting;

    public itemsListPickPackages: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2PoFinishKeyno = this.stateService.getStateParams()['p2_pofinish_keyno'];
        this.custactNo = this.stateService.getStateParams()['custact_no'];
    }

    private async loadSetting() {
        if (!!this.p2PoFinishKeyno && !!this.custactNo) {
            this.setting = (await this.datatask.Post(875, {
                p2_pofinish_keyno: this.p2PoFinishKeyno,
                custact_no: this.custactNo
            }))[0];
        }
    }

    private async loadPickPackages() {
        if (!!this.p2PoFinishKeyno && !!this.custactNo) {
            this.itemsListPickPackages = await this.datatask.Post(871, {
                p2_pofinish_keyno: this.p2PoFinishKeyno,
                custact_no: this.custactNo
            });
        }
    }

    private async init() {
        this.loadSetting();
        this.loadPickPackages();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    filtervalue: string;
    webpagename: string;
    parms: string;
    nbr_of_packages: string;
}
